export enum AuthType {
  UsernamePassword = 'username_password',
  Phone = 'phone',
  GoogleSSO = 'google_sso',
}
